import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusCardOverlinehead], [campus-card-overline-head], campus-card-overline-head',
})
export class CardOverlineheadDirective {
  @HostBinding('class')
  defaultClasses = ['label-overline', 'opacity-medium'];
}
